exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-view[data-v-2c55e936]{width:100px;height:100px;background:#eee;border-radius:4px;cursor:pointer}.upload-view i[data-v-2c55e936]{font-size:20px;font-weight:600}.w400[data-v-2c55e936]{width:400px}\n", ""]);

// exports
